// represents the amount of space between comments with 'spread' being slightly
// greater spacing than 'default'
export type CommentSpacing = 'spread' | 'default';

export enum CommentContentType {
  WHITEBOARD = 'WHITEBOARD',
  DATABASE = 'DATABASE',
  SLIDE = 'SLIDE',
}

export enum CommentAnalyticsType {
  WHITEBOARD = 'whiteboard',
  DATABASE = 'database',
  SLIDE = 'slide',
}

export enum ReactionsResourceType {
  whiteboard = 'whiteboard',
  database = 'database',
  slide = 'slide',
}

export const mapCommentContentTypeToResourceType = (
  contentType: CommentContentType
): ReactionsResourceType | undefined => {
  switch (contentType) {
    case CommentContentType.WHITEBOARD:
      return ReactionsResourceType.whiteboard;
    case CommentContentType.DATABASE:
      return ReactionsResourceType.database;
    case CommentContentType.SLIDE:
      return ReactionsResourceType.slide;
    default:
      return undefined;
  }
};
